const { ethers } = require('ethers');
const { stakehouseContracts } = require('@blockswaplab/stakehouse-protocol-abis');
const { lsdContracts } = require('@blockswaplab/lsd-protocol-abis');
const { _getChainSpecificConstants, _extractChainID } = require('./constants.js');
const GOERLI_MULTIPARTY_ABI = require('../ABI/goerli_multiparty_abi.json');

const getContractInstance = async (signer) => {

    const chainID = await _extractChainID(signer);
    const values = _getChainSpecificConstants(chainID);

    const getAccountManager = () => new ethers.Contract(
        values.stakehouseAddresses.ACCOUNT_MANAGER,
        stakehouseContracts.ACCOUNT_MANAGER,
        signer
    );

    const getTransactionRouter = () => new ethers.Contract(
        values.stakehouseAddresses.TRANSACTION_ROUTER,
        stakehouseContracts.TRANSACTION_ROUTER,
        signer
    );

    const getGenericERC20Contract = (tokenAddress) => new ethers.Contract(
        tokenAddress,
        stakehouseContracts.ERC20_GENERIC,
        signer
    );

    const getdETHContract = () => new ethers.Contract(
        values.stakehouseAddresses.DETH,
        stakehouseContracts.ERC20_GENERIC,
        signer
    );

    const getSafeBox = () => new ethers.Contract(
        values.stakehouseAddresses.SAFE_BOX,
        stakehouseContracts.SAFE_BOX,
        signer
    );

    const getSavETHBatchTransaction = () => new ethers.Contract(
        values.stakehouseAddresses.SAVETH_BATCH_TX,
        stakehouseContracts.SAVETH_BATCH_TX,
        signer
    );

    const getSavETHRegistry = () => new ethers.Contract(
        values.stakehouseAddresses.SAVETH_REGISTRY,
        stakehouseContracts.SAVETH_REGISTRY,
        signer
    );

    const getSavETHManager = () => new ethers.Contract(
        values.stakehouseAddresses.SAVETH_MANAGER,
        stakehouseContracts.SAVETH_MANAGER,
        signer
    );

    const getSlotSettlementRegistry = () => new ethers.Contract(
        values.stakehouseAddresses.SLOT_SETTLEMENT_REGISTRY,
        stakehouseContracts.SLOT_SETTLEMENT_REGISTRY,
        signer
    );

    const getSavETHIndexNamingRegistry = () => new ethers.Contract(
        values.stakehouseAddresses.SAVETH_INDEX_NAMING_REGISTRY,
        stakehouseContracts.SAVETH_INDEX_NAMING_REGISTRY,
        signer
    );

    const getStakehouseUniverse = () => new ethers.Contract(
        values.stakehouseAddresses.STAKEHOUSE_UNIVERSE,
        stakehouseContracts.UNIVERSE,
        signer
    );

    const getHouseRagequitAdaptor = () => new ethers.Contract(
        values.stakehouseAddresses.HOUSE_RAGE_QUIT_ADAPTOR,
        stakehouseContracts.TRANSACTION_ROUTER,
        signer
    );

    // shall be removed after Stakehouse smart contracts are redeployed on Goerli
    const getGoerliMultipartyRagequit = () => new ethers.Contract(
        values.stakehouseAddresses.TRANSACTION_ROUTER,
        GOERLI_MULTIPARTY_ABI,
        signer
    );

    const getLiquidStakingManager = (liquidStakingManagerAddress) => new ethers.Contract(
        liquidStakingManagerAddress,
        lsdContracts.LIQUID_STAKING_MANAGER,
        signer
    );

    const getGiantSavETHPool = () => new ethers.Contract(
        values.stakehouseAddresses.GIANT_SAVETH_POOL,
        lsdContracts.GIANT_PROTECTED_STAKING,
        signer
    );

    const getGiantFeesAndMEV = () => new ethers.Contract(
        values.stakehouseAddresses.GIANT_FEES_AND_MEV_POOL,
        lsdContracts.GIANT_FEES_AND_MEV,
        signer
    );

    const getGiantLPToken = (tokenAddress) => new ethers.Contract(
        tokenAddress,
        lsdContracts.GIANT_LP,
        signer
    );

    const getSyndicate = (syndicateAddress) => new ethers.Contract(
        syndicateAddress,
        lsdContracts.SYNDICATE,
        signer
    );

    const getSmartWalletNamingRegistry = () => new ethers.Contract(
        values.stakehouseAddresses.SMART_WALLET_NAMING_REGISTRY,
        lsdContracts.SMART_WALLET_NAMING_REGISTRY,
        signer
    );

    const getSavETHPool = (savETHPoolAddress) => new ethers.Contract(
        savETHPoolAddress,
        lsdContracts.GIANT_PROTECTED_STAKING,
        signer
    );

    return {
        accountManager: getAccountManager,
        transactionRouter: getTransactionRouter,
        genericERC20Contract: getGenericERC20Contract,
        dETHContract: getdETHContract,
        safeBox: getSafeBox,
        savETHBatch: getSavETHBatchTransaction,
        savETHRegistry: getSavETHRegistry,
        savETHManager: getSavETHManager,
        slotSettlementRegistry: getSlotSettlementRegistry,
        savETHIndexNamingRegistry: getSavETHIndexNamingRegistry,
        stakehouseUniverse: getStakehouseUniverse,
        houseRagequitAdaptor: getHouseRagequitAdaptor,
        goerliMultipartyRagequit: getGoerliMultipartyRagequit,
        liquidStakingManager: getLiquidStakingManager,
        giantSavETHPool: getGiantSavETHPool,
        giantFeesAndMEV: getGiantFeesAndMEV,
        giantLPToken: getGiantLPToken,
        syndicate: getSyndicate,
        smartWalletNaming: getSmartWalletNamingRegistry,
        savETHPool: getSavETHPool
    };
};

module.exports = {
    getContractInstance
};
